// extracted by mini-css-extract-plugin
export default {"signBox":"create_signBox__w9PQ2","title":"create_title__50uFy","submitButton":"create_submitButton__3hkl4"};